import {defineMessages, FormattedMessage} from 'react-intl';

import {WarningOutlined} from '@ant-design/icons';

import commonMessages from '../CommonMessages/commonMessages';
import LocalizedModal from '../LocalizedModal/LocalizedModal';

const messages = defineMessages({
  title: {
    id: 'CloseConfirmationModal.title',
    defaultMessage: 'Discard Changes',
  },
  content: {
    id: 'CloseConfirmationModal.content',
    defaultMessage: 'Your changes have not been saved and will be discarded.',
  },
});

export default function CloseConfirmationModal(
  {
    title,
    content,
    maskClosable = true,
    showCancel = true,
    className = 'CloseConfirmationModal',
    icon = <WarningOutlined className="danger" />,
    okText = <FormattedMessage {...commonMessages.ok} />,
    zIndex,
  },
  okCallback = () => {},
  cancelCallback = () => {},
) {
  LocalizedModal.confirm({
    className,
    icon: icon,
    maskClosable: maskClosable,
    title: title || <FormattedMessage {...messages.title} />,
    content: content || <FormattedMessage {...messages.content} />,
    okButtonProps: {danger: true},
    okText: okText,
    ...(zIndex != null ? {zIndex} : {}),
    cancelButtonProps: !showCancel ? {style: {display: 'none'}} : undefined,
    cancelText: <FormattedMessage {...commonMessages.cancel} />,
    onOk() {
      okCallback();
    },
    onCancel() {
      cancelCallback();
    },
  });
}
